import BaseApi from "./BaseApi";

class UserApi extends BaseApi {
  
  // fetchUser
  static async fetchUser() {
    try {
      const { data: { session } } = await this.supabase.auth.getSession();
      if (!session) {
        throw new Error("No active session");
      }
      const { data: { user }, error: authError } = await this.supabase.auth.getUser();
      if (authError) {
        throw new Error(`Authentication Error: ${authError.message}`);
      }
      return user;
    } catch (error) {
      console.error("Error fetching authenticated user:", error);
      throw error; 
    }
  }
  
  //  updateUser Name
  static async updateUserProfile(updatedData) {
    try {
      const { data, error } = await this.supabase.auth.updateUser({
        data: {
          name: updatedData.name,
        },
      });

      if (error) {
        throw new Error(`Update Error: ${error.message}`);
      }


      return data;
    } catch (error) {
      console.error("Error updating user profile:", error);
      throw error;
    }
  }
}

export default UserApi;
